package pl.michal_cyran.brand_hub.subpages.tutoring.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.icons.fa.FaMessage
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.FeaturedCardStyle
import pl.michal_cyran.brand_hub.HeroGridStyle
import pl.michal_cyran.brand_hub.components.widgets.BigBadge
import pl.michal_cyran.brand_hub.components.widgets.FeaturedButton
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware

@Composable
fun TutoringPrice() {
    VisibilityAware { isVisible ->
        SimpleGrid(
            numColumns(base = 1, md = 2),
            HeroGridStyle.toModifier()
        ) {
            Column(
                modifier = Modifier
                    .opacity(if (isVisible) 1 else 0)
                    .transform { translateY(if (isVisible) 0.px else 24.px) }
                    .transition(
                        Transition.of("opacity", 0.6.s, EaseOut, 0.ms),
                        Transition.of("transform", 0.6.s, EaseOut, 0.ms)
                    )
            ) {
                H2 {
                    Text("Cennik korepetycji – jasne i uczciwe zasady")
                }

                P {
                    Text(
                        "Inwestycja w skuteczną naukę. Oferuję jedną stałą stawkę za pełną godzinę zegarową (60 minut) korepetycji z matematyki oraz informatyki w Krakowie i online."
                    )
                }

                SimpleGrid(
                    numColumns(2, md = 2),
                    modifier = Modifier.gap(1.cssRem)
                ) {
                    BigBadge("60 minut lekcji", "clock")
                    BigBadge("Brak ukrytych kosztów", "circle-check")
                }
            }

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .opacity(if (isVisible) 1 else 0)
                    .transform {
                        translateY(if (isVisible) 0.px else 24.px)
                        scale(if (isVisible) 1.0 else 0.95)
                    }
                    .transition(
                        Transition.of("opacity", 0.6.s, EaseOut, 150.ms),
                        Transition.of("transform", 0.6.s, EaseOut, 150.ms)
                    ),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Column(
                    FeaturedCardStyle.toModifier(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                ) {
                    H3 {
                        Text("Stawka za 60 minut")
                    }

                    H3 {
                        SpanText("90", modifier = Modifier.fontSize(2.cssRem))
                        SpanText("PLN", modifier = Modifier.fontSize(2.cssRem))
                    }

                    HorizontalDivider()

                    FeaturedButton(
                        path = "#kontakt",
                        text = "Zarezerwuj termin",
                        icon = { FaMessage() }
                    )
                }
            }
        }
    }
}